/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { createNotFoundLayoutStyles } from './NotFoundLayout.styles';

type NotFoundLayoutProps = {
  children: any;
};

export function NotFoundLayout(props: NotFoundLayoutProps) {
  const { children } = props;
  const classes = createNotFoundLayoutStyles();

  return <div className={classes.root}>{children}</div>;
}
